export default __webpack_public_path__ + "cc4b1aaf7e820bede8cc18b4f5f1de42.png";